import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { ReactComponent as CrossIcon } from '../../../Assets/Images/close-circle-grey.svg';
import { isImageFile } from '../../../utils/util.js';

const DocumentHeader = ({
	data,
	docName,
	currentPage,
	totalPages,
	numPages,
	isMobile,
	showDetails,
	isEsignFlow,
	close,
	setDocumentLoading,
	combinedDoc,
	showOptions
}) => {
	if (!showOptions) {
		return null;
	}

	const totalPageCount = isEsignFlow ? totalPages : numPages;
	return (
		<Box sx={{ marginBottom: '8px', marginTop: isMobile ? '8px' : '0px' }}>
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<div>{data?.documentName || docName || '-'}</div>
				{!isImageFile(combinedDoc) && (
					<div>
						{totalPageCount > 0 && <p>
							{currentPage}/
							{totalPageCount || 'Loading...'}
						</p>}
					</div>
				)}
				{!showDetails && !isMobile && (
					<Box
						onClick={() => {
							setDocumentLoading(true);
							close();
						}}
					>
						<CrossIcon
							style={{
								stroke: 'white',
								cursor: 'pointer',
								width: '24px',
								height: '24px'
							}}
						/>
					</Box>
				)}
			</div>
		</Box>
	);
};

DocumentHeader.propTypes = {
	data: PropTypes.any,
	docName: PropTypes.string,
	currentPage: PropTypes.number,
	totalPages: PropTypes.number,
	numPages: PropTypes.number,
	isMobile: PropTypes.bool,
	showDetails: PropTypes.bool,
	isEsignFlow: PropTypes.bool,
	close: PropTypes.func,
	setDocumentLoading: PropTypes.func,
	combinedDoc: PropTypes.string,
	showOptions: PropTypes.bool
};

export default DocumentHeader;
